import { allow } from '../classes/allow';

const mbiRegex = /^[1-9]{1}(?![SLOIB])[A-Ya-y]{1}(?![SLOIB])[A-Ya-y0-9]{1}[0-9]{1}-?(?![SLOIB])[A-Ya-y]{1}(?![SLOIB])[A-Ya-y0-9]{1}[0-9]{1}-?(?![SLOIB])[A-Ya-y]{2}[0-9]{2}$/;

export function isValidMedicareNumber(medicareNumber = '') {
   allow.aString(medicareNumber);
   return !!medicareNumber.match(mbiRegex);
}